module.exports = __webpack_public_path__ + "img/index-handle1.ba325844.png";